/**
 * ═══════════════════════════════════════════════════════════════
 *  BELSU — Shopify Theme JavaScript
 *  Adaptado para Shopify AJAX API
 *  Vanilla JS · Sem dependências externas
 * ═══════════════════════════════════════════════════════════════
 */

document.addEventListener('DOMContentLoaded', () => {

  /* ───────────────────────────────────────────────────────────
   *  1. COMPORTAMENTO DO HEADER AO ROLAR
   *  Esconde ao descer, reaparece ao subir.
   *  Adiciona classe compacta após 100 px.
   * ─────────────────────────────────────────────────────────── */
  const header = document.getElementById('header');

  if (header) {
    let lastScroll = 0;
    let ticking   = false;

    window.addEventListener('scroll', () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const currentScroll = window.scrollY;

          if (currentScroll > 100) {
            header.classList.add('header--scrolled');
          } else {
            header.classList.remove('header--scrolled');
          }

          if (currentScroll > lastScroll && currentScroll > 200) {
            header.classList.add('header--hidden');
          } else {
            header.classList.remove('header--hidden');
          }

          lastScroll = currentScroll;
          ticking    = false;
        });
        ticking = true;
      }
    });
  }


 /* ───────────────────────────────────────────────────────────
 *  2. MENU LATERAL
 *  Abre e fecha pela direita
 * ─────────────────────────────────────────────────────────── */

const menuToggles = document.querySelectorAll('[data-menu-toggle]');
const mobileMenu = document.querySelector('[data-mobile-menu]');
const menuOverlay = document.querySelector('[data-mobile-menu-overlay]');
const menuClose = document.querySelector('[data-mobile-menu-close]');

function openMobileMenu() {
  if (!mobileMenu) return;

  mobileMenu.classList.add('active');
  mobileMenu.setAttribute('aria-hidden', 'false');

  if (menuOverlay) {
    menuOverlay.classList.add('active');
  }

  menuToggles.forEach((button) => {
    button.classList.add('active');
    button.setAttribute('aria-expanded', 'true');
  });

  document.body.style.overflow = 'hidden';
}

function closeMobileMenu() {
  if (!mobileMenu) return;

  mobileMenu.classList.remove('active');
  mobileMenu.setAttribute('aria-hidden', 'true');

  if (menuOverlay) {
    menuOverlay.classList.remove('active');
  }

  menuToggles.forEach((button) => {
    button.classList.remove('active');
    button.setAttribute('aria-expanded', 'false');
  });

  document.body.style.overflow = '';
}

function toggleMobileMenu() {
  if (!mobileMenu) return;

  if (mobileMenu.classList.contains('active')) {
    closeMobileMenu();
  } else {
    openMobileMenu();
  }
}

menuToggles.forEach((button) => {
  button.addEventListener('click', toggleMobileMenu);
});

if (menuClose) {
  menuClose.addEventListener('click', closeMobileMenu);
}

if (menuOverlay) {
  menuOverlay.addEventListener('click', closeMobileMenu);
}

document.addEventListener('keydown', (event) => {
  if (
    event.key === 'Escape' &&
    mobileMenu &&
    mobileMenu.classList.contains('active')
  ) {
    closeMobileMenu();
  }
});


  /* ───────────────────────────────────────────────────────────
   *  3. OVERLAY DE BUSCA
   *  Usa data-* attributes padronizados
   * ─────────────────────────────────────────────────────────── */
  const searchToggle  = document.querySelector('[data-search-toggle]');
  const searchOverlay = document.querySelector('.search-overlay');
  const searchClose   = document.querySelector('[data-search-close]');
  const searchInput   = searchOverlay
    ? searchOverlay.querySelector('input[type="text"], input[type="search"]')
    : null;

  function openSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    if (searchInput) {
      setTimeout(() => searchInput.focus(), 300);
    }
  }

  function closeSearch() {
    if (!searchOverlay) return;
    searchOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (searchToggle) searchToggle.addEventListener('click', openSearch);
  if (searchClose)  searchClose.addEventListener('click', closeSearch);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && searchOverlay && searchOverlay.classList.contains('active')) {
      closeSearch();
    }
  });


  /* ───────────────────────────────────────────────────────────
   *  4. GAVETA DO CARRINHO (Cart Drawer)
   *  Usa data-* attributes e Shopify AJAX Cart API
   * ─────────────────────────────────────────────────────────── */
  const cartToggle  = document.querySelector('[data-cart-toggle]');
  const cartDrawer  = document.querySelector('.cart-drawer');
  const cartOverlay = document.querySelector('.cart-overlay');
  const cartClose   = cartDrawer
    ? cartDrawer.querySelector('[data-cart-close]')
    : null;

  function openCart() {
    if (cartDrawer)  cartDrawer.classList.add('active');
    if (cartOverlay) cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeCart() {
    if (cartDrawer)  cartDrawer.classList.remove('active');
    if (cartOverlay) cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (cartToggle) cartToggle.addEventListener('click', openCart);
  if (cartClose)  cartClose.addEventListener('click', closeCart);
  if (cartOverlay) cartOverlay.addEventListener('click', closeCart);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('active')) {
      closeCart();
    }
  });


  /* ───────────────────────────────────────────────────────────
   *  SHOPIFY CART API — Funções auxiliares
   * ─────────────────────────────────────────────────────────── */

  /**
   * Busca o estado atual do carrinho via AJAX.
   * @returns {Promise<Object>} dados do carrinho
   */
  async function fetchCart() {
    const res = await fetch('/cart.js', {
      headers: { 'Content-Type': 'application/json' }
    });
    return res.json();
  }

  /**
   * Adiciona um item ao carrinho.
   * @param {number|string} variantId — ID da variante
   * @param {number} quantity — quantidade (default 1)
   * @returns {Promise<Object>} dados do item adicionado
   */
  async function addToCart(variantId, quantity = 1) {
    const res = await fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        items: [{ id: parseInt(variantId), quantity: quantity }]
      })
    });
    return res.json();
  }

  /**
   * Atualiza a quantidade de um item no carrinho.
   * @param {string} key — chave do item no carrinho
   * @param {number} quantity — nova quantidade (0 = remover)
   * @returns {Promise<Object>} dados do carrinho atualizado
   */
  async function updateCartItem(key, quantity) {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    });
    return res.json();
  }

  /**
   * Atualiza o HTML do cart drawer via fetch da página.
   */
  async function refreshCartDrawer() {
    try {
      const res = await fetch('/?sections=cart-drawer');
      const data = await res.json();
      const html = data['cart-drawer'];

      if (cartDrawer && html) {
        // Extrair apenas o conteúdo interno
        const temp = document.createElement('div');
        temp.innerHTML = html;
        const newDrawer = temp.querySelector('.cart-drawer');
        if (newDrawer) {
          cartDrawer.innerHTML = newDrawer.innerHTML;
          // Re-attach close button
          const newClose = cartDrawer.querySelector('[data-cart-close]');
          if (newClose) newClose.addEventListener('click', closeCart);
        }
      }

      // Atualizar contadores de carrinho
      const cart = await fetchCart();
      updateCartCounters(cart.item_count);
    } catch (err) {
      console.error('Erro ao atualizar carrinho:', err);
    }
  }

  /**
   * Atualiza todos os contadores de carrinho na página.
   * @param {number} count — número de itens
   */
  function updateCartCounters(count) {
    const counters = document.querySelectorAll('.cart-count, [data-cart-count]');
    counters.forEach(el => {
      el.textContent = count;
      if (count > 0) {
        el.style.display = '';
      }
    });
  }


  /* ───────────────────────────────────────────────────────────
   *  5. SLIDER DO HERO
   *  Avanço automático a cada 5 s, navegação por setas e dots.
   *  Pausa ao passar o mouse.
   * ─────────────────────────────────────────────────────────── */
  const heroSlider = document.querySelector('[data-hero-slider]') || document.querySelector('.hero__slider');

  if (heroSlider) {
    const slides = document.querySelectorAll('.hero__slide');
    const dots   = document.querySelectorAll('.hero__dot');
    let currentSlide     = 0;
    let autoplayInterval = null;

    function goToSlide(index) {
      currentSlide = index;
      heroSlider.style.transform = `translateX(-${currentSlide * 100}%)`;
      slides.forEach((s, i) => s.classList.toggle('active', i === currentSlide));
      dots.forEach((d, i)   => d.classList.toggle('active', i === currentSlide));
    }

    function nextSlide() {
      goToSlide((currentSlide + 1) % slides.length);
    }

    function prevSlide() {
      goToSlide((currentSlide - 1 + slides.length) % slides.length);
    }

    goToSlide(0);

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => {
        goToSlide(i);
        resetAutoplay();
      });
    });

    const prevArrow = document.querySelector('[data-hero-prev]') || document.querySelector('.hero__arrow--prev');
    const nextArrow = document.querySelector('[data-hero-next]') || document.querySelector('.hero__arrow--next');

    if (prevArrow) {
      prevArrow.addEventListener('click', () => { prevSlide(); resetAutoplay(); });
    }
    if (nextArrow) {
      nextArrow.addEventListener('click', () => { nextSlide(); resetAutoplay(); });
    }

    function startAutoplay() {
      autoplayInterval = setInterval(nextSlide, 5000);
    }

    function resetAutoplay() {
      clearInterval(autoplayInterval);
      startAutoplay();
    }

    startAutoplay();

    const hero = document.querySelector('.hero');
    if (hero) {
      hero.addEventListener('mouseenter', () => clearInterval(autoplayInterval));
      hero.addEventListener('mouseleave', startAutoplay);
    }
  }


  /* ───────────────────────────────────────────────────────────
   *  6. FILTROS DA PÁGINA DE COLEÇÃO
   *  Colapsar grupos, gaveta mobile.
   *  Filtros conectados ao Shopify Storefront Filtering (URL-based).
   * ─────────────────────────────────────────────────────────── */

  // Colapsar / expandir grupos de filtro
  const filterHeaders = document.querySelectorAll('.filter-group__header');

  filterHeaders.forEach((headerEl) => {
    headerEl.addEventListener('click', () => {
      const group = headerEl.closest('.filter-group');
      if (group) group.classList.toggle('collapsed');
    });
  });

  // Gaveta de filtros — mobile
  const filterToggle  = document.querySelector('.filter-toggle');
  const filterDrawer  = document.querySelector('.filter-drawer');
  const filterClose   = filterDrawer
    ? filterDrawer.querySelector('.filter-drawer__close')
    : null;
  const filterOverlay = document.querySelector('.filter-overlay');

  function openFilterDrawer() {
    if (filterDrawer)  filterDrawer.classList.add('active');
    if (filterOverlay) filterOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeFilterDrawer() {
    if (filterDrawer)  filterDrawer.classList.remove('active');
    if (filterOverlay) filterOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (filterToggle)  filterToggle.addEventListener('click', openFilterDrawer);
  if (filterClose)   filterClose.addEventListener('click', closeFilterDrawer);
  if (filterOverlay) filterOverlay.addEventListener('click', closeFilterDrawer);


  /* ───────────────────────────────────────────────────────────
   *  7. PÁGINA DE DETALHE DO PRODUTO
   *  Troca de imagem, seleção de variante, accordion.
   * ─────────────────────────────────────────────────────────── */

  // 7a — Galeria do produto: miniaturas e zoom
  const gallery = document.querySelector('[data-product-gallery]');
  const galleryMain = gallery ? gallery.querySelector('[data-gallery-main]') : null;
  const mainImage = gallery ? gallery.querySelector('[data-main-image]') : null;
  const thumbs = gallery ? Array.from(gallery.querySelectorAll('[data-thumb]')) : [];
  const zoomButton = gallery ? gallery.querySelector('[data-gallery-zoom]') : null;

  let currentGalleryIndex = Math.max(
    0,
    thumbs.findIndex((thumb) => thumb.classList.contains('active'))
  );

  function setMainGalleryImage(index) {
    if (!mainImage || thumbs.length === 0) return;

    const safeIndex = Math.max(0, Math.min(index, thumbs.length - 1));
    const thumb = thumbs[safeIndex];
    const imageUrl =
      thumb.getAttribute('data-image-url') ||
      (thumb.querySelector('img') ? thumb.querySelector('img').src : '');

    if (!imageUrl) return;

    mainImage.src = imageUrl;
    mainImage.srcset = '';

    thumbs.forEach((item, itemIndex) => {
      item.classList.toggle('active', itemIndex === safeIndex);
    });

    currentGalleryIndex = safeIndex;
  }

  thumbs.forEach((thumb, index) => {
    thumb.addEventListener('click', () => {
      setMainGalleryImage(index);
    });
  });

  function createGalleryModal() {
    let modal = document.querySelector('[data-gallery-modal]');

    if (modal) return modal;

    modal = document.createElement('div');
    modal.className = 'product-gallery-modal';
    modal.setAttribute('data-gallery-modal', '');
    modal.setAttribute('aria-hidden', 'true');

    modal.innerHTML = `
      <div class="product-gallery-modal__backdrop" data-gallery-modal-close></div>

      <div
        class="product-gallery-modal__dialog"
        role="dialog"
        aria-modal="true"
        aria-label="Imagem ampliada do produto"
      >
        <button
          type="button"
          class="product-gallery-modal__close"
          data-gallery-modal-close
          aria-label="Fechar imagem ampliada"
        >
          ×
        </button>

        <button
          type="button"
          class="product-gallery-modal__nav product-gallery-modal__nav--prev"
          data-gallery-modal-prev
          aria-label="Imagem anterior"
        >
          ‹
        </button>

        <div class="product-gallery-modal__stage">
          <img
            class="product-gallery-modal__image"
            data-gallery-modal-image
            src=""
            alt=""
          >
        </div>

        <button
          type="button"
          class="product-gallery-modal__nav product-gallery-modal__nav--next"
          data-gallery-modal-next
          aria-label="Próxima imagem"
        >
          ›
        </button>
      </div>
    `;

    document.body.appendChild(modal);

    modal.querySelectorAll('[data-gallery-modal-close]').forEach((button) => {
      button.addEventListener('click', closeGalleryModal);
    });

    const previousButton = modal.querySelector('[data-gallery-modal-prev]');
    const nextButton = modal.querySelector('[data-gallery-modal-next]');

    if (previousButton) {
      previousButton.addEventListener('click', () => navigateGalleryModal(-1));
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => navigateGalleryModal(1));
    }

    const modalImage = modal.querySelector('[data-gallery-modal-image]');
    const stage = modal.querySelector('.product-gallery-modal__stage');

    if (modalImage && stage) {
      let isDragging = false;
      let dragMoved = false;
      let startX = 0;
      let startY = 0;
      let startScrollLeft = 0;
      let startScrollTop = 0;

      function resetZoom() {
        modalImage.classList.remove('is-zoomed');
        stage.classList.remove('is-dragging');
        stage.scrollTop = 0;
        stage.scrollLeft = 0;
      }

      modalImage.addEventListener('click', (event) => {
        event.stopPropagation();

        if (dragMoved) {
          dragMoved = false;
          return;
        }

        modalImage.classList.toggle('is-zoomed');

        if (!modalImage.classList.contains('is-zoomed')) {
          resetZoom();
        } else {
          requestAnimationFrame(() => {
            stage.scrollLeft = Math.max(
              0,
              (stage.scrollWidth - stage.clientWidth) / 2
            );
            stage.scrollTop = Math.max(
              0,
              (stage.scrollHeight - stage.clientHeight) / 2
            );
          });
        }
      });

      stage.addEventListener('pointerdown', (event) => {
        if (!modalImage.classList.contains('is-zoomed')) return;

        isDragging = true;
        dragMoved = false;
        startX = event.clientX;
        startY = event.clientY;
        startScrollLeft = stage.scrollLeft;
        startScrollTop = stage.scrollTop;

        stage.classList.add('is-dragging');
        stage.setPointerCapture(event.pointerId);
        event.preventDefault();
      });

      stage.addEventListener('pointermove', (event) => {
        if (!isDragging) return;

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        if (Math.abs(deltaX) > 3 || Math.abs(deltaY) > 3) {
          dragMoved = true;
        }

        stage.scrollLeft = startScrollLeft - deltaX;
        stage.scrollTop = startScrollTop - deltaY;
      });

      function stopDragging(event) {
        if (!isDragging) return;

        isDragging = false;
        stage.classList.remove('is-dragging');

        if (event && stage.hasPointerCapture(event.pointerId)) {
          stage.releasePointerCapture(event.pointerId);
        }
      }

      stage.addEventListener('pointerup', stopDragging);
      stage.addEventListener('pointercancel', stopDragging);
      stage.addEventListener('pointerleave', (event) => {
        if (isDragging && event.buttons === 0) stopDragging(event);
      });

      stage.addEventListener(
        'wheel',
        (event) => {
          if (!modalImage.classList.contains('is-zoomed')) return;

          event.preventDefault();
          stage.scrollLeft += event.deltaX || event.deltaY;
          stage.scrollTop += event.shiftKey ? 0 : event.deltaY;
        },
        { passive: false }
      );

      modal.__belsuResetZoom = resetZoom;
    }

    return modal;
  }

  function openGalleryModal() {
    if (!mainImage) return;

    const modal = createGalleryModal();
    const modalImage = modal.querySelector('[data-gallery-modal-image]');

    if (!modalImage) return;

    modalImage.src = mainImage.currentSrc || mainImage.src;
    modalImage.alt = mainImage.alt || '';

    if (typeof modal.__belsuResetZoom === 'function') {
      modal.__belsuResetZoom();
    } else {
      modalImage.classList.remove('is-zoomed');
      const stage = modal.querySelector('.product-gallery-modal__stage');
      if (stage) {
        stage.scrollTop = 0;
        stage.scrollLeft = 0;
      }
    }

    modal.classList.add('is-open');
    modal.setAttribute('aria-hidden', 'false');
    document.body.classList.add('product-gallery-modal-open');
  }

  function closeGalleryModal() {
    const modal = document.querySelector('[data-gallery-modal]');

    if (!modal) return;

    modal.classList.remove('is-open');
    modal.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('product-gallery-modal-open');
  }

  function navigateGalleryModal(direction) {
    if (thumbs.length === 0) return;

    const nextIndex =
      (currentGalleryIndex + direction + thumbs.length) % thumbs.length;

    setMainGalleryImage(nextIndex);

    const modalImage = document.querySelector('[data-gallery-modal-image]');

    if (modalImage && mainImage) {
      modalImage.src = mainImage.currentSrc || mainImage.src;
      modalImage.alt = mainImage.alt || '';
      modalImage.classList.remove('is-zoomed');

      const stage = document.querySelector('.product-gallery-modal__stage');
      if (stage) {
        stage.scrollTop = 0;
        stage.scrollLeft = 0;
      }
    }
  }

  if (galleryMain) {
    galleryMain.addEventListener('click', (event) => {
      if (event.target.closest('[data-gallery-zoom]')) return;
      openGalleryModal();
    });
  }

  if (zoomButton) {
    zoomButton.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      openGalleryModal();
    });
  }

  document.addEventListener('keydown', (event) => {
    const modal = document.querySelector('[data-gallery-modal].is-open');

    if (!modal) return;

    if (event.key === 'Escape') closeGalleryModal();
    if (event.key === 'ArrowLeft') navigateGalleryModal(-1);
    if (event.key === 'ArrowRight') navigateGalleryModal(1);
  });

  // 7b — Seleção de variantes (Tamanho + Cor)
  // Atualiza corretamente o ID da variante antes de adicionar ao carrinho.
  const productForm = document.querySelector('[data-product-form]');
  const variantInput = productForm
    ? productForm.querySelector('input[name="id"], [data-variant-id]')
    : null;
  const productData = document.querySelector('[data-product-json]');
  let productVariants = [];

  function normalizeVariantData(data) {
    if (Array.isArray(data)) return data;
    if (data && Array.isArray(data.variants)) return data.variants;
    if (data && data.product && Array.isArray(data.product.variants)) {
      return data.product.variants;
    }
    return [];
  }

  if (productData) {
    try {
      productVariants = normalizeVariantData(
        JSON.parse(productData.textContent)
      );
    } catch (error) {
      console.error('Erro ao ler as variantes do produto:', error);
    }
  }

  async function loadProductVariants() {
    if (productVariants.length > 0) return productVariants;

    try {
      const productUrl = window.location.pathname.replace(/\/$/, '');
      const response = await fetch(`${productUrl}.js`, {
        headers: { Accept: 'application/json' }
      });

      if (!response.ok) {
        throw new Error(`Não foi possível carregar o produto (${response.status})`);
      }

      const data = await response.json();
      productVariants = normalizeVariantData(data);
    } catch (error) {
      console.error('Erro ao carregar as variantes:', error);
    }

    return productVariants;
  }

  function getSelectedOptions() {
    const groups = Array.from(
      document.querySelectorAll('[data-product-info] [data-option-index]')
    );

    return groups
      .sort(
        (a, b) =>
          Number(a.dataset.optionIndex) - Number(b.dataset.optionIndex)
      )
      .map((group) => {
        const selected = group.querySelector(
          '.color-selector__option.active, .size-option.active'
        );

        return selected
          ? (selected.getAttribute('data-option-value') || '').trim()
          : '';
      });
  }

  function findSelectedVariant() {
    const selectedOptions = getSelectedOptions();

    if (
      productVariants.length === 0 ||
      selectedOptions.length === 0 ||
      selectedOptions.some((value) => value === '')
    ) {
      return null;
    }

    return productVariants.find((variant) => {
      if (!Array.isArray(variant.options)) return false;

      return selectedOptions.every(
        (selectedValue, index) =>
          String(variant.options[index]).trim() === selectedValue
      );
    }) || null;
  }

  function applySelectedVariant(variant) {
    if (!variant) return false;

    if (variantInput) {
      variantInput.value = String(variant.id);
      variantInput.setAttribute('value', String(variant.id));
    }

    const priceEl = document.querySelector('.product-info__price-current');
    if (priceEl && typeof variant.price === 'number') {
      priceEl.textContent = formatMoney(variant.price);
    }

    const comparePriceEl = document.querySelector(
      '.product-info__price-original'
    );

    if (comparePriceEl) {
      if (
        variant.compare_at_price &&
        variant.compare_at_price > variant.price
      ) {
        comparePriceEl.textContent = formatMoney(variant.compare_at_price);
        comparePriceEl.style.display = '';
      } else {
        comparePriceEl.style.display = 'none';
      }
    }

    const addButton = productForm
      ? productForm.querySelector(
          '.product-info__add-to-cart, [data-add-to-cart-btn]'
        )
      : null;

    if (addButton) {
      addButton.disabled = !variant.available;
      addButton.textContent = variant.available
        ? 'Adicionar à Sacola'
        : 'Esgotado';
    }

    if (variant.featured_image && mainImage) {
      const imageElement =
        mainImage.tagName === 'IMG'
          ? mainImage
          : mainImage.querySelector('img');

      const imageSource =
        variant.featured_image.src ||
        variant.featured_image.url ||
        '';

      if (imageElement && imageSource) {
        imageElement.src = imageSource;
        imageElement.srcset = '';
      }
    }

    const url = new URL(window.location.href);
    url.searchParams.set('variant', variant.id);
    window.history.replaceState({}, '', url.toString());

    return true;
  }

  async function updateVariant() {
    await loadProductVariants();
    const variant = findSelectedVariant();

    if (!variant) {
      console.warn(
        'Nenhuma variante encontrada para as opções:',
        getSelectedOptions()
      );
      return null;
    }

    applySelectedVariant(variant);
    return variant;
  }

  function formatMoney(cents) {
    const numericValue = Number(cents);

    if (!Number.isFinite(numericValue)) {
      return 'R$ 0,00';
    }

    return new Intl.NumberFormat('pt-BR', {
      style: 'currency',
      currency: 'BRL'
    }).format(numericValue / 100);
  }

  const sizeOptions = document.querySelectorAll(
    '[data-product-info] .size-option'
  );

  sizeOptions.forEach((button) => {
    button.addEventListener('click', async () => {
      if (button.disabled || button.classList.contains('disabled')) return;

      const group = button.closest('[data-option-index]');
      if (!group) return;

      group
        .querySelectorAll('.size-option')
        .forEach((item) => item.classList.remove('active'));

      button.classList.add('active');
      await updateVariant();
    });
  });

  const colorOptions = document.querySelectorAll(
    '[data-product-info] .color-selector__option'
  );

  colorOptions.forEach((button) => {
    button.addEventListener('click', async () => {
      const group = button.closest('[data-option-index]');
      if (!group) return;

      group
        .querySelectorAll('.color-selector__option')
        .forEach((item) => item.classList.remove('active'));

      button.classList.add('active');

      const colorLabel = group.querySelector('[data-selected-color]');
      if (colorLabel) {
        colorLabel.textContent =
          button.getAttribute('data-option-value') || '';
      }

      await updateVariant();
    });
  });

  loadProductVariants().then(() => {
    const variantFromUrl = new URL(window.location.href).searchParams.get(
      'variant'
    );

    if (variantFromUrl) {
      const initialVariant = productVariants.find(
        (variant) => String(variant.id) === String(variantFromUrl)
      );

      if (initialVariant) {
        applySelectedVariant(initialVariant);
        return;
      }
    }

    updateVariant();
  });

  // 7d — Accordion (detalhes, medidas, entrega…)
  const accordionItems = document.querySelectorAll('.accordion__item');

  accordionItems.forEach((item) => {
    const trigger = item.querySelector('.accordion__header');
    if (!trigger) return;

    trigger.addEventListener('click', () => {
      const isOpen = item.classList.contains('open');
      accordionItems.forEach((other) => other.classList.remove('open'));
      if (!isOpen) item.classList.add('open');
    });
  });

  // 7e — Botão de lista de desejos na página de detalhe
  const detailWishlist = document.querySelector('.product-info__wishlist');

  if (detailWishlist) {
    detailWishlist.addEventListener('click', () => {
      detailWishlist.classList.toggle('active');
      pulseAnimation(detailWishlist);
      // Wishlist localStorage
      const productId = detailWishlist.getAttribute('data-product-id');
      if (productId) toggleWishlistItem(productId);
    });
  }


  /* ───────────────────────────────────────────────────────────
   *  8. WISHLIST — localStorage
   *  Salva IDs de produto no localStorage.
   * ─────────────────────────────────────────────────────────── */

  function pulseAnimation(el) {
    el.classList.add('pulse');
    el.addEventListener('animationend', () => el.classList.remove('pulse'), { once: true });
  }

  function getWishlist() {
    try {
      return JSON.parse(localStorage.getItem('belsu_wishlist') || '[]');
    } catch {
      return [];
    }
  }

  function saveWishlist(list) {
    localStorage.setItem('belsu_wishlist', JSON.stringify(list));
    updateWishlistCount();
  }

  function toggleWishlistItem(productId) {
    let list = getWishlist();
    const index = list.indexOf(productId);
    if (index > -1) {
      list.splice(index, 1);
    } else {
      list.push(productId);
    }
    saveWishlist(list);
  }

  function isInWishlist(productId) {
    return getWishlist().includes(productId);
  }

  function updateWishlistCount() {
    const count = getWishlist().length;
    const counters = document.querySelectorAll('[data-wishlist-count]');
    counters.forEach(el => {
      el.textContent = count;
      el.style.display = count > 0 ? '' : 'none';
    });
  }

  // Marcar itens já favoritados ao carregar
  function syncWishlistButtons() {
    const wishlist = getWishlist();
    const buttons = document.querySelectorAll('[data-wishlist-toggle]');
    buttons.forEach(btn => {
      const productId = btn.getAttribute('data-product-id');
      if (productId && wishlist.includes(productId)) {
        btn.classList.add('active');
      }
    });
  }

  // Delegação de evento — funciona para cards carregados dinamicamente
  document.addEventListener('click', (e) => {
    const wishBtn = e.target.closest('[data-wishlist-toggle], .product-card__wishlist');
    if (!wishBtn) return;

    e.preventDefault();
    e.stopPropagation();
    wishBtn.classList.toggle('active');
    pulseAnimation(wishBtn);

    const productId = wishBtn.getAttribute('data-product-id');
    if (productId) toggleWishlistItem(productId);
  });

  // Init wishlist
  updateWishlistCount();
  syncWishlistButtons();


  /* ───────────────────────────────────────────────────────────
   *  9. BOTÃO VOLTAR AO TOPO
   * ─────────────────────────────────────────────────────────── */
  const backToTop = document.querySelector('.back-to-top');

  if (backToTop) {
    window.addEventListener('scroll', () => {
      if (window.scrollY > 500) {
        backToTop.classList.add('visible');
      } else {
        backToTop.classList.remove('visible');
      }
    });

    backToTop.addEventListener('click', () => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    });
  }


  /* ───────────────────────────────────────────────────────────
   *  10. ANIMAÇÕES DE REVELAÇÃO AO ROLAR (Scroll Reveal)
   * ─────────────────────────────────────────────────────────── */
  const revealElements = document.querySelectorAll('.reveal');

  if (revealElements.length > 0) {
    const revealObserver = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add('visible');
            const children = entry.target.querySelectorAll('[class*="reveal-delay"]');
            children.forEach((child, i) => {
              child.style.transitionDelay = `${i * 0.1}s`;
              child.classList.add('visible');
            });
            revealObserver.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.1 }
    );

    revealElements.forEach((el) => revealObserver.observe(el));
  }


  /* ───────────────────────────────────────────────────────────
   *  11. CARD DE PRODUTO — HOVER NO MOBILE
   * ─────────────────────────────────────────────────────────── */
  function handleMobileCards() {
    const isMobile = window.matchMedia('(max-width: 768px)').matches;
    const wishBtns = document.querySelectorAll('.product-card__wishlist, [data-wishlist-toggle]');

    wishBtns.forEach((btn) => {
      btn.style.opacity = isMobile ? '1' : '';
      btn.style.pointerEvents = isMobile ? 'auto' : '';
    });
  }

  handleMobileCards();
  window.addEventListener('resize', handleMobileCards);


  /* ───────────────────────────────────────────────────────────
   *  12. ALTERNÂNCIA DE VISUALIZAÇÃO — GRADE (Shopping)
   * ─────────────────────────────────────────────────────────── */
  const viewBtns    = document.querySelectorAll('.shop-toolbar__view-btn');
  const productGrid = document.querySelector('.product-grid');

  viewBtns.forEach((btn) => {
    btn.addEventListener('click', () => {
      viewBtns.forEach((b) => b.classList.remove('active'));
      btn.classList.add('active');

      if (productGrid) {
        const cols = btn.getAttribute('data-cols');
        if (cols) {
          productGrid.style.gridTemplateColumns = `repeat(${cols}, 1fr)`;
        }
      }
    });
  });


  /* ───────────────────────────────────────────────────────────
   *  13. ADICIONAR À SACOLA — Shopify AJAX API
   *  Conecta ao /cart/add.js e atualiza o drawer.
   * ─────────────────────────────────────────────────────────── */

  function animateCartIcon() {
    if (cartToggle) {
      cartToggle.classList.add('cart-bounce');
      cartToggle.addEventListener(
        'animationend',
        () => cartToggle.classList.remove('cart-bounce'),
        { once: true }
      );
    }
  }

  // Botão "Adicionar à Sacola" na página de produto (via form)
  if (productForm) {
    productForm.addEventListener('submit', async (e) => {
      e.preventDefault();

      const addBtn = productForm.querySelector('.product-info__add-to-cart, [type="submit"]');
      const originalText = addBtn ? addBtn.textContent : '';

      if (addBtn) {
        addBtn.disabled = true;
        addBtn.textContent = 'Adicionando...';
      }

      try {
        const selectedVariant = await updateVariant();
        const formData = new FormData(productForm);
        const varId = selectedVariant
          ? selectedVariant.id
          : formData.get('id');
        const qty = parseInt(formData.get('quantity') || '1', 10);

        if (!varId) {
          throw new Error('Nenhuma variante foi selecionada.');
        }

        await addToCart(varId, qty);
        await refreshCartDrawer();
        animateCartIcon();
        openCart();

        if (addBtn) {
          addBtn.textContent = 'Adicionado ✓';
          setTimeout(() => {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          }, 2000);
        }
      } catch (err) {
        console.error('Erro ao adicionar ao carrinho:', err);
        if (addBtn) {
          addBtn.textContent = 'Erro — Tente novamente';
          setTimeout(() => {
            addBtn.textContent = originalText;
            addBtn.disabled = false;
          }, 2000);
        }
      }
    });
  }

  // Botão rápido "Add to Cart" nos product cards (delegação de evento)
  document.addEventListener('click', async (e) => {
    const addBtn = e.target.closest('[data-add-to-cart]');
    if (!addBtn) return;

    e.preventDefault();
    e.stopPropagation();

    const variantId = addBtn.getAttribute('data-variant-id');
    if (!variantId) return;

    addBtn.classList.add('loading');

    try {
      await addToCart(variantId, 1);
      await refreshCartDrawer();
      animateCartIcon();

      addBtn.classList.remove('loading');
      addBtn.classList.add('added');
      setTimeout(() => addBtn.classList.remove('added'), 1500);
    } catch (err) {
      console.error('Erro ao adicionar ao carrinho:', err);
      addBtn.classList.remove('loading');
    }
  });

  // Delegação para botões de quantidade e remoção no cart drawer
  document.addEventListener('click', async (e) => {
    // Botão de remover item
    const removeBtn = e.target.closest('[data-cart-remove]');
    if (removeBtn) {
      e.preventDefault();
      const key = removeBtn.getAttribute('data-cart-item-key');
      if (key) {
        await updateCartItem(key, 0);
        await refreshCartDrawer();
      }
      return;
    }

    // Botões de quantidade (+/-)
    const qtyBtn = e.target.closest('[data-cart-qty]');
    if (qtyBtn) {
      e.preventDefault();
      const key = qtyBtn.getAttribute('data-cart-item-key');
      const action = qtyBtn.getAttribute('data-cart-qty');
      const qtyEl = qtyBtn.parentElement.querySelector('[data-cart-qty-value]');
      let qty = parseInt(qtyEl ? qtyEl.textContent : '1');

      if (action === 'minus') qty = Math.max(0, qty - 1);
      if (action === 'plus') qty += 1;

      await updateCartItem(key, qty);
      await refreshCartDrawer();
    }
  });


  /* ───────────────────────────────────────────────────────────
   *  14. WISHLIST PAGE — Carregar produtos do localStorage
   * ─────────────────────────────────────────────────────────── */
  const wishlistGrid = document.querySelector('[data-wishlist-grid]');

  if (wishlistGrid) {
    loadWishlistProducts();
  }

  async function loadWishlistProducts() {
    const wishlist = getWishlist();
    const emptyState = document.querySelector('[data-wishlist-empty]');
    const countEl = document.querySelector('[data-wishlist-total]');

    if (wishlist.length === 0) {
      if (emptyState) emptyState.style.display = '';
      if (wishlistGrid) wishlistGrid.style.display = 'none';
      if (countEl) countEl.textContent = '0 itens salvos';
      return;
    }

    if (emptyState) emptyState.style.display = 'none';
    if (wishlistGrid) wishlistGrid.style.display = '';
    if (countEl) countEl.textContent = `${wishlist.length} ${wishlist.length === 1 ? 'item salvo' : 'itens salvos'}`;

    // Fetch each product
    wishlistGrid.innerHTML = '<div class="wishlist-loading">Carregando favoritos...</div>';

    const productCards = [];

    for (const handle of wishlist) {
      try {
        const res = await fetch(`/products/${handle}.json`);
        if (res.ok) {
          const data = await res.json();
          productCards.push(renderWishlistCard(data.product));
        }
      } catch (err) {
        console.error(`Erro ao carregar produto ${handle}:`, err);
      }
    }

    wishlistGrid.innerHTML = productCards.join('');
    syncWishlistButtons();
  }

  function renderWishlistCard(product) {
    const image = product.images && product.images[0]
      ? product.images[0].src
      : '';
    const price = formatMoney(product.variants[0].price * 100);
    const comparePrice = product.variants[0].compare_at_price
      ? formatMoney(product.variants[0].compare_at_price * 100)
      : '';
    const variantId = product.variants[0].id;

    return `
      <article class="product-card">
        <a href="/products/${product.handle}" class="product-card__link">
          <div class="product-card__image-wrap">
            ${image ? `<img src="${image}" alt="${product.title}" loading="lazy">` : '<div style="background: #e8d5c4; width: 100%; height: 100%;"></div>'}
            <button class="product-card__wishlist active" data-wishlist-toggle data-product-id="${product.handle}" aria-label="Remover dos favoritos">
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" stroke="currentColor" stroke-width="1.5"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>
            </button>
          </div>
        </a>
        <div class="product-card__info">
          <span class="product-card__brand">${product.vendor}</span>
          <h3 class="product-card__name"><a href="/products/${product.handle}">${product.title}</a></h3>
          <div class="product-card__price">
            <span class="product-card__price-current">${price}</span>
            ${comparePrice ? `<span class="product-card__price-original">${comparePrice}</span>` : ''}
          </div>
        </div>
      </article>
    `;
  }


  /* ───────────────────────────────────────────────────────────
   *  UTILITÁRIO: Injeção de estilos para animações JS
   * ─────────────────────────────────────────────────────────── */
  const dynamicStyles = document.createElement('style');
  dynamicStyles.textContent = `
    @keyframes pulse {
      0%   { transform: scale(1);   }
      50%  { transform: scale(1.3); }
      100% { transform: scale(1);   }
    }
    .pulse {
      animation: pulse 0.35s ease;
    }

    @keyframes cartBounce {
      0%   { transform: scale(1);    }
      40%  { transform: scale(1.25); }
      70%  { transform: scale(0.9);  }
      100% { transform: scale(1);    }
    }
    .cart-bounce {
      animation: cartBounce 0.4s ease;
    }

    @keyframes pop {
      0%   { transform: scale(1);   }
      50%  { transform: scale(1.4); }
      100% { transform: scale(1);   }
    }
    .pop {
      animation: pop 0.3s ease;
    }

    .loading { opacity: 0.5; pointer-events: none; }
    .added { color: var(--color-success, #2d7d46); }
    .wishlist-loading {
      grid-column: 1 / -1;
      text-align: center;
      padding: 3rem;
      color: var(--color-text-muted, #999);
      font-size: 0.875rem;
    }
  `;
  document.head.appendChild(dynamicStyles);

}); // fim DOMContentLoaded